var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAToBoDirectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 40,
    viewBox: "0 0 20 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#024EC9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 51,
    r: 10,
    fill: "#024EC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#024EC9",
    strokeWidth: 2,
    d: "M10 22v16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.396 5.408h1.86L14.484 14h-1.788l-.72-2.052H8.688L7.968 14H6.18l3.216-8.592zm2.052 5.052l-.756-2.16-.312-1.032h-.096L9.972 8.3l-.768 2.16h2.244zM6.984 46.408h3.36c.48 0 .92.1 1.32.3.408.2.728.472.96.816.232.344.348.72.348 1.128 0 .432-.108.808-.324 1.128a2.065 2.065 0 01-.828.72v.096c.448.16.804.416 1.068.768.264.344.396.76.396 1.248 0 .472-.128.892-.384 1.26-.248.36-.588.64-1.02.84a3.394 3.394 0 01-1.416.288h-3.48v-8.592zm3.24 3.504c.352 0 .632-.096.84-.288a.973.973 0 00.324-.744.94.94 0 00-.312-.72c-.2-.2-.468-.3-.804-.3H8.604v2.052h1.62zm.18 3.612c.392 0 .696-.1.912-.3.224-.208.336-.476.336-.804 0-.328-.112-.596-.336-.804-.224-.208-.544-.312-.96-.312H8.604v2.22h1.8z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAToBoDirectionIcon);
export default __webpack_public_path__ + "static/media/a-to-bo-direction-icon.68ca9c9eeb6fdcdd471ac322a03d1768.svg";
export { ForwardRef as ReactComponent };